import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// react components for routing our app without refresh

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import { Share } from "@material-ui/icons";

import Footer from "components/Footer/Footer.jsx";

// @material-ui/icons
// core components
import Header from "components/Header/Header.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Parallax from "components/Parallax/Parallax.jsx";
// sections for this page
import HeaderLinks from "components/Header/HeaderLinks.jsx";
//import SectionMGEC from "./Sections/SectionMGEC.jsx";
import SectionServices from "./Sections/SectionServices.jsx";
import SectionLogo from "./Sections/SectionLogo.jsx";
import componentsStyle from "assets/jss/material-kit-react/views/components.jsx";

class Components extends React.Component {
  
  render() {
      const { classes, ...rest } = this.props;
    return (
      <div>
       <Header
          brand="MGEC" 
          rightLinks={<HeaderLinks />}
          fixed
          color="white"
          changeColorOnScroll={{
            height: 400,
            color: "white"
          }}
          {...rest}
        />
        <Parallax image={require("assets/img/bgw.jpg")}>
          <div className={classes.container}>
           <GridContainer>
              <GridItem xs={12} sm={6}>             
                         <br />
                <div className={classes.brand}>
                    <h2 className={classes.title}>MGEC<Button color="transparent"><Share /></Button>
                    </h2>
                    <h5 className={classes.subtitle}>
                    <i class="fa fa-quote-left" style={IconStyle}></i>
                    Aims to be trustworthy and accountable partner for both business partners and clients.
                    <i class="fa fa-quote-right" style={IconStyle}></i>
                    </h5>
                    <br />
                    <br />
                    <p className={classes.description}>
                  Myanmar Gateway Engineering & Consultancy Group
                   </p>
                  <br />
                </div>

              </GridItem>
              </GridContainer>
          </div>

        </Parallax>
        <div>
        <SectionLogo />
        </div>
          <br/>
          <br/>
        <div className={classNames(classes.main, classes.mainRaised)}>
           
          <SectionServices />
        </div>
        
      <br />

        <Footer />

      </div>
     
       
     
    );
  }
}
const IconStyle={
    fontSize: '24px',
    paddingLeft: '2px',
    paddingRight: '5px',
}

export default withStyles(componentsStyle)(Components);



// WEBPACK FOOTER //
// ./src/views/Components/Components.jsx